var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferSuprise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Suprise_Delight",
    "data-name": "Suprise & Delight",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.505,
    height: 26.474,
    viewBox: "0 0 26.505 26.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13193",
    "data-name": "Group 13193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13192",
    "data-name": "Group 13192",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5053",
    "data-name": "Rectangle 5053",
    width: 3.457,
    height: 12.676,
    transform: "translate(11.524 13.797)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M22.261,278.926a.575.575,0,0,0,.576.576H31.48V266.826H22.261Z",
    transform: "translate(-21.109 -253.029)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5884",
    "data-name": "Path 5884",
    d: "M311.652,279.5h8.643a.576.576,0,0,0,.576-.576v-12.1h-9.219Z",
    transform: "translate(-295.519 -253.03)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5885",
    "data-name": "Path 5885",
    d: "M25.929,7.186H17.818a7.761,7.761,0,0,0,1.974-1.375,3.243,3.243,0,0,0,0-4.588,3.32,3.32,0,0,0-4.589,0,8.949,8.949,0,0,0-1.951,3.3,8.952,8.952,0,0,0-1.952-3.3,3.318,3.318,0,0,0-4.588,0,3.243,3.243,0,0,0,0,4.588A7.74,7.74,0,0,0,8.687,7.186H.576A.576.576,0,0,0,0,7.762v4.61a.575.575,0,0,0,.576.576h9.8V7.878a11.693,11.693,0,0,0,1.152.312v4.757h3.457V8.191a11.835,11.835,0,0,0,1.152-.312v5.069h9.8a.576.576,0,0,0,.576-.576V7.762A.576.576,0,0,0,25.929,7.186Zm-13.25,0h-.065A9.268,9.268,0,0,1,7.527,5a2.092,2.092,0,1,1,2.958-2.958,9.271,9.271,0,0,1,2.194,5.13C12.68,7.174,12.679,7.181,12.679,7.186Zm1.211,0h-.063s0-.012,0-.017a9.267,9.267,0,0,1,2.193-5.13A2.092,2.092,0,1,1,18.978,5,9.268,9.268,0,0,1,13.89,7.186Z",
    transform: "translate(0 -0.303)",
    fill: "#ed8b00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSuprise);
export default __webpack_public_path__ + "static/media/offer_suprise.059c18e611d56da71a6f07383efc657d.svg";
export { ForwardRef as ReactComponent };